<template>
  <!-- Start Boxes Area -->
  <section class="boxes-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-box">
            <div class="icon">
              <vue-feather type="server"></vue-feather>
            </div>
            <h3>Réseaux informatiques</h3>
            <p>
              Les réseaux informatiques ou d’entreprise LAN/WAN/WLAN et leurs
              applications font l’objet de nombreuses initiatives qui
              nourrissent une forte demande sur le marché de l’emploi en
              techniciens/Ingénieurs. Vous serez formé à devenir des
              administrateurs réseaux capables de concevoir, de paramétrer et
              d’administrer des réseaux de données de type IP utilisant les
              technologies LAN et WAN.
            </p>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-box bg-f78acb">
            <div class="icon">
              <vue-feather type="code"></vue-feather>
            </div>
            <h3>Developpement web</h3>
            <p>
              Apprennez les outils necessaires pour developper des sites et des
              applications web. Devenez full-stack en maitrisant plusieurs
              languages de programmation et donnez vous les moyens de creer tout
              types d'applications pour repondre aux défis du futur.
            </p>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-box bg-c679e3">
            <div class="icon">
              <vue-feather type="users"></vue-feather>
            </div>
            <h3>Teams</h3>
            <p>
              Integrez un groupe de personne aussi motivé et passioné que vous,
              et réalisez votre plein potentiel ensemble!
            </p>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-box bg-eb6b3d">
            <div class="icon">
              <vue-feather type="git-branch"></vue-feather>
            </div>
            <h3>Ameliorez vous</h3>
            <p>
              Terminez les modules un à un, connectez les acquis en cours et
              réalisez vos objectifs!
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End Boxes Area -->
</template>
